import { cloneDeep } from "lodash";

export const updateData = (data, dependencyRequired, dependencyFields) => {
  let copyData = cloneDeep(data);
  copyData[0].required = dependencyRequired;
  copyData[0].formFields = dependencyFields;
  return copyData;
};
